module.exports = __webpack_public_path__ + "img/hk_title.9bb81dfb.jpg";